var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-menu-item',{attrs:{"index":_vm.data.route}},[_c('i',{class:_vm.iconClass}),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.data.name))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }